import axios from 'axios';
import {
  ACTIVITY_ALL_FAIL,
  ACTIVITY_ALL_REQUEST,
  ACTIVITY_ALL_SUCCESS,
  ACTIVITY_BY_ID_FAIL,
  ACTIVITY_BY_ID_REQUEST,
  ACTIVITY_BY_ID_SUCCESS,
  ACTIVITY_DELETE_FAIL,
  ACTIVITY_DELETE_REQUEST,
  ACTIVITY_DELETE_SUCCESS,
  ACTIVITY_NEW_FAIL,
  ACTIVITY_NEW_REQUEST,
  ACTIVITY_NEW_SUCCESS,
  ACTIVITY_UPDATE_BY_ID_FAIL,
  ACTIVITY_UPDATE_BY_ID_REQUEST,
  ACTIVITY_UPDATE_BY_ID_SUCCESS,
} from '../constants/activityConstant';

export const newActivity =
  (title, body, category, activityPhoto, date) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ACTIVITY_NEW_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        '/api/activity',
        {
          title,
          body,
          category,
          activityPhoto,
          date,
        },
        config
      );

      dispatch({
        type: ACTIVITY_NEW_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ACTIVITY_NEW_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const allactivities =
  (checkChapter, keyword = '', pageNumber = '') =>
  async (dispatch) => {
    try {
      dispatch({
        type: ACTIVITY_ALL_REQUEST,
      });

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const { data } = await axios.get(
        `/api/activity/chapter/${checkChapter}?keyword=${keyword}&page=${pageNumber}`,
        config
      );

      dispatch({
        type: ACTIVITY_ALL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ACTIVITY_ALL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getActivityById = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_BY_ID_REQUEST,
    });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(`/api/activity/${id}`, config);

    dispatch({
      type: ACTIVITY_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ACTIVITY_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateActivityById =
  (id, title, body, category, uploadedFiles, date) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ACTIVITY_UPDATE_BY_ID_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/activity/${id}`,
        { title, body, category, uploadedFiles, date },
        config
      );

      dispatch({
        type: ACTIVITY_UPDATE_BY_ID_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ACTIVITY_UPDATE_BY_ID_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteActivity = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ACTIVITY_DELETE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/activity/${id}`, config);

    dispatch({ type: ACTIVITY_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: ACTIVITY_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
